/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useContext, useEffect, useRef, useState } from 'react'

import { sitePath } from '../../../assets/ts/api/api'
import { mpfRListsHttp } from '../../../assets/ts/api/mpf-r-lists-http'
import { COLUMN_NAMES as DueOutColumns } from '../../../assets/ts/data/dueout/dueout-discussions'
import {
  encodeHTML,
  formatBody,
  sendEmail,
  sendNotification,
} from '../../../assets/ts/general/general'
import ActionButtons from '../../../components/buttons/action-buttons'
import Buttons from '../../../components/buttons/buttons'
import { UserContext } from '../../../store/user-context-provider'
import { DiscussionCols } from '../../../utils/constants/global-list-columns'
import InputCheckbox from '../../../utils/controls/input-checkbox'
import InputSelect from '../../../utils/controls/input-select'
import InputText from '../../../utils/controls/input-text'
import InputTextArea from '../../../utils/controls/input-text-area'

const initialValues = ['addDiscussion']
let elementHeightValue: number
let fixedPopupLeftvalue: number
let fixedPopupTopValue: number
let offsetLeftValue: number
let offsetTopValue: number
let offsetWidthValue: number
let popupTop: number
let xPositionValue: any

const AddDiscussion = (props: any) => {
  /** *** Responsive Popup Code Start*****/
  const { multiplePopup, setMultiplePopup } = useContext(UserContext)

  const addDiscussion = useRef<any>(null)
  const popupBtnRef = useRef<any>(null)

  const [popupHeight, setPopupHeight] = useState<number>()
  const [xPositionValueUpdate, setXPositionValueUpdate] = useState<number>()

  const [actionBtnShowHide, setActionBtnShowHide] = useState({
    addDiscussion: false,
  })
  const [showActionPopups, setShowActionPopups] = useState({
    addDiscussion: false,
  })
  const [disable, setDisable] = useState(false)
  const [discType, setDiscType] = useState<'Customer' | 'Internal'>('Customer')
  const [fieldsData, setFieldsData] = useState({ DiscComment: '', DiscSubject: '' })
  const [validation, setValidation] = useState({
    DiscComment: false,
    DiscSubj: false,
  })
  const [selectedFiles, setSelectedFiles] = useState('')
  const [allFiles, setAllFiles] = useState<any>([])
  const popupWidthData = popupBtnRef.current ? popupBtnRef.current.offsetWidth : 0
  const popupHeightData = popupBtnRef.current ? popupBtnRef.current.clientHeight : 0
  const fixedPopUpRightAlign = fixedPopupLeftvalue - popupWidthData + offsetWidthValue

  const showHide: any = { ...actionBtnShowHide }
  const [showButton, setShowButton] = useState<boolean>(false)
  function popupCloseOpenFunctionality(
    type: any,
    value: any,
    top: number,
    xPosition: number,
    left: number,
    elementHeight: number,
    offsetWidth: number,
    menuExpanded?: any
  ) {
    setDiscType('Customer')
    setShowButton(!showButton)
    popupTop = top
    xPositionValue = xPosition
    offsetLeftValue = left
    offsetTopValue = top
    offsetWidthValue = offsetWidth
    // fixedPopupTopValue = fixedPopupTopValue
    // fixedPopupLeftValue = fixedPopupLeftValue
    initialValues.forEach((element: any) => {
      showHide[element] = false
    })
    setFieldsData({ ...fieldsData, DiscComment: '', DiscSubject: '' })
    setValidation({ ...validation, DiscComment: false, DiscSubj: false })
    setSelectedFiles('')
    setActionBtnShowHide(showHide)
    if (type) {
      setActionBtnShowHide({ ...showHide, [type]: value })
      setShowActionPopups({ ...showHide, [type]: value })
    }
    if (type === multiplePopup && !menuExpanded) {
      setMultiplePopup()
    } else if (type && !menuExpanded) {
      setMultiplePopup(type)
    } else if (menuExpanded && type) {
      setMultiplePopup(type)
    }
  }

  useEffect(() => {
    setPopupHeight(window.innerHeight - (offsetTopValue + 65))
    const popupWidthData = popupBtnRef.current ? popupBtnRef.current.offsetWidth : 0
    // setpopupwidth(popupWidthData)
    if (popupWidthData < xPositionValue) {
      xPositionValue = xPositionValue - popupWidthData
      setXPositionValueUpdate(xPositionValue)
    } else if (
      popupWidthData > offsetLeftValue &&
      popupWidthData < window.innerWidth - (offsetLeftValue + offsetWidthValue)
    ) {
      xPositionValue = offsetLeftValue
      setXPositionValueUpdate(xPositionValue)
    } else if (
      popupWidthData > offsetLeftValue &&
      popupWidthData > window.innerWidth - (offsetLeftValue + offsetWidthValue)
    ) {
      xPositionValue = 0
      setXPositionValueUpdate(xPositionValue)
    }
  }, [showActionPopups, multiplePopup])
  async function addDiscussions() {
    const userdetails = await mpfRListsHttp().me()
    const userId = userdetails.userId
    setDisable(true)
    const validationset = { DiscComment: false, DiscSubj: false }
    const subject = encodeHTML(fieldsData?.DiscSubject?.trim())
    const comment = encodeHTML(fieldsData?.DiscComment?.trim())
    if (!subject) {
      validationset.DiscSubj = true
    }
    if (!comment) {
      validationset.DiscComment = true
    }
    const DiscussionColsGUID = props?.isInquiry
      ? DiscussionCols.InquiryGUID
      : DueOutColumns.DueOutGUID
    const DiscussionColsID = props?.isInquiry ? DiscussionCols.InquiryID : DueOutColumns.DueOutID

    const ObjectArray = {}
    ObjectArray[DiscussionCols.Comment] = comment
    ObjectArray[DiscussionColsID] = props?.GUID
    ObjectArray[DiscussionCols.IsActionComment] = false
    ObjectArray[DiscussionCols.ItemCreated] = new Date()
    ObjectArray[DiscussionCols.ItemCreatedBy] = userId
    ObjectArray[DiscussionColsGUID] = props?.GUID
    ObjectArray[DiscussionCols.ItemModified] = new Date()
    ObjectArray[DiscussionCols.ItemModifiedBy] = userId
    ObjectArray[DiscussionCols.Subject] = subject
    ObjectArray[DiscussionCols.CommentType] = discType
    ObjectArray[DiscussionCols.CommentDocumentName] = selectedFiles
    ObjectArray[DiscussionCols.UserRole] = props.role
    
    if (!validationset.DiscSubj && !validationset.DiscComment) {
      try {
        const InqOrDueOutList = props?.isInquiry
          ? 'InquiryDiscussionsList'
          : 'DueOutDiscussionsList'
        const DiscussionList = await mpfRListsHttp().getList(InqOrDueOutList)
        await DiscussionList.addOrUpdateItem(ObjectArray).then(() => {
          setActionBtnShowHide({ ...actionBtnShowHide, addDiscussion: false })
          props?.refreshData()
          setMultiplePopup()
        })
        if (discType === 'Customer') {
          await handleEmails(subject, comment, userdetails)
          await sendNotification(
            'CUSTOMER_DISCUSSION_ADD',
            props?.currentInquiry,
            userdetails,
            props?.role?.replace('[SECTION_NAME]', '').trim() || '',
            !props?.isInquiry
          )
        } else {
          await sendNotification(
            'INTERNAL_DISCUSSION_ADD',
            props?.currentInquiry,
            userdetails,
            props?.role?.replace('[SECTION_NAME]', '').trim() || '',
            !props?.isInquiry
          )
        }
      } catch (error) {
        console.error('error', error)
      }
    } else {
      setDisable(false)
      setValidation({
        ...validation,
        DiscComment: validationset.DiscComment,
        DiscSubj: validationset.DiscSubj,
      })
    }
  }

  const handleEmails = async (subject, comment, userdetails) => {
    const userId = userdetails.userId
    const detailView = props?.isInquiry ? 'detailview' : 'dueoutdetailview'
    const dataGUID = props?.isInquiry
      ? props?.currentInquiry?.InquiryGUID
      : props?.currentInquiry?.DueOutGUID
    const dataId = props?.isInquiry
      ? props?.currentInquiry?.InquiryID
      : props?.currentInquiry?.DueOutID
    const navURL = sitePath + `/${detailView}/${dataGUID}`
    let bodyText = ''
    if (selectedFiles !== '') {
      bodyText = `New comment has been added for ${selectedFiles}.`
    }
    const emailBodyData = {
      ...props?.currentInquiry,
      Title: subject,
      bodyText: bodyText,
      comment: comment,
    }

    const body = formatBody('Discussion', emailBodyData, navURL)
    const to = props?.currentInquiry?.Customer?.userID
    const formattedRole = props?.role?.replace('[SECTION_NAME]', '').trim() || ''

    const emailObjData = {
      ...props?.currentInquiry,
      Action: discType === 'Internal' ? 'Add Internal Discussion' : 'Add Customer Discussion',
      ItemGUID: dataGUID,
      ItemID: dataId,
      Title: props?.currentInquiry?.Subject,
    }

    const emails: Promise<any>[][] = []

    if (to && to !== userId) {
      emails.push(
        sendEmail({
          bcc: '',
          bodySurvey: '',
          cc: '',
          data: emailObjData,
          discussion: body,
          isDiscussion: true,
          isSurvey: false,
          loginuserId: userId,
          navURL: navURL,
          subject: `${
            props?.isInquiry ? 'Inquiry' : 'Due Out'
          } '${dataId}' – New discussion comment has been added ${
            formattedRole && `by '${formattedRole}'`
          }`,
          to: to,
        })
      )
    }

    if (props?.currentInquiry?.TeamMembers?.length > 0) {
      const teamMembers = props?.currentInquiry?.TeamMembers
      for (const teamMember of teamMembers) {
        if (teamMember.userID !== userId) {
          emails.push(
            sendEmail({
              bcc: '',
              bodySurvey: '',
              cc: '',
              data: emailObjData,
              discussion: body,
              isDiscussion: true,
              isSurvey: false,
              loginuserId: userId,
              navURL: navURL,
              subject: `${
                props?.isInquiry ? 'Inquiry' : 'Due Out'
              } '${dataId}' – New discussion comment has been added ${
                formattedRole && `by '${formattedRole}'`
              }`,
              to: teamMember.userID,
            })
          )
        }
      }
    }

    await Promise.all(emails)
  }

  function DiscussionSubject(e: Event) {
    setFieldsData({ ...fieldsData, DiscSubject: e.target.value })
  }
  function DiscussionComment(e: Event) {
    setFieldsData({ ...fieldsData, DiscComment: e.target.value })
  }
  useEffect(() => {
    const filesArray = []
    if (props?.allFiles?.length > 0) {
      props?.allFiles?.forEach((element) => {
        filesArray.push(element?.fileName)
      })
      setAllFiles(filesArray)
    } else {
      setAllFiles([])
    }
  }, [props?.allFiles])
  useEffect(() => {
    const element = document.getElementsByClassName('discussions-div')
    if (element) {
      setTimeout(() => {
        element?.[0]?.scrollIntoView({ behavior: 'smooth', block: 'end' })
      }, 100)
    }
  }, [showButton])

  useEffect(() => {
    const element: any = document.getElementsByClassName('menus')
    if (multiplePopup === 'addDiscussion') {
      if (element && element[0]?.classList?.contains('menuexpand')) {
        setMultiplePopup(undefined)
        Promise.all([setActionBtnShowHide({ ...actionBtnShowHide, addDiscussion: false })]).then(
          () => {
            setTimeout(() => {
              showPopup()
            }, 200)
          }
        )
      }
      if (element && element[0]?.classList?.contains('menucollapsed')) {
        setMultiplePopup(undefined)
        Promise.all([setActionBtnShowHide({ ...actionBtnShowHide, addDiscussion: false })]).then(
          () => {
            setTimeout(() => {
              showPopup()
            }, 200)
          }
        )
      }
    }
  }, [props?.isMenusExpanded])

  const showPopup = () => {
    const ele: any = document.getElementById('addDiscussion')
    const elementHeight = ele.offsetHeight
    const offSetTopValue = ele.offsetTop
    const popupTop = elementHeight + offSetTopValue
    const offsetWidthValue = ele.offsetWidth
    const offsetLeftValue = ele.offsetLeft
    const popupLeft = offsetWidthValue + offsetLeftValue
    popupCloseOpenFunctionality(
      'addDiscussion',
      true,
      popupTop,
      popupLeft,
      offsetLeftValue,
      elementHeight,
      offsetWidthValue,
      true
    )
  }
  return (
    <>
      <ActionButtons
        btnClassName='ms-auto'
        className={
          multiplePopup === 'addDiscussion'
            ? 'btn-border btn btn-sm font-0 font-xxl-14 color-primary btn-border-radius3 p-relative popup-arrow  ms-auto sourcesansprosemibold'
            : 'btn-border btn btn-sm font-0 font-xxl-14 color-primary btn-border-radius3 p-relative sourcesansprosemibold  ms-auto'
        }
        icon='icon-add color-primary font-10 me-xxl-1 bold'
        id='addDiscussion'
        isClick='addDiscussion'
        label='Add Discussion'
        name='Add Discussion'
        popupCloseOpenFunctionality={popupCloseOpenFunctionality}
        ref={addDiscussion}
        showHide={actionBtnShowHide.addDiscussion}
        type='button'
      />
      {multiplePopup === 'addDiscussion' ? (
        <div
          className='popup popup-sm'
          ref={popupBtnRef}
          style={{
            left: xPositionValueUpdate,
            maxHeight: popupHeight,
            overflow: 'auto',
            position: 'absolute',
            top: popupTop + 8,
          }}
        >
          <div className='row'>
            <div className='d-flex align-items-center col-md-12 mt-0 mb-2'>
              <InputCheckbox
                formClassName='d-flex align-items-center'
                inputProps={{
                  arialabel: 'Customer',
                  checked: discType === 'Customer' ? true : false,
                  className: 'font-12 poppins-medium title-color2 mx-2',
                  id: 'Customer',
                  label: 'Customer',
                  name: 'DiscussionOptions',
                  type: 'radio',
                  value: 'Customer',
                }}
                onChange={() => setDiscType('Customer')}
              />
              {props?.role !== 'Customer' && (
                <InputCheckbox
                  formClassName='d-flex align-items-center'
                  inputProps={{
                    arialabel: 'Internal',
                    checked: discType === 'Internal' ? true : false,
                    className: 'font-12 poppins-medium title-color2 mx-2',
                    id: 'Internal',
                    label: 'Internal',
                    name: 'DiscussionOptions',
                    type: 'radio',
                    value: 'Internal',
                  }}
                  onChange={() => setDiscType('Internal')}
                />
              )}
            </div>
            <div className='col-dm-12 mb-2 mt-0'>
              <InputText
                changeHandler={DiscussionSubject}
                className='form-sm font-13 sourcesanspro'
                error={validation.DiscSubj}
                formClassName=' form-vertical'
                info='Subject'
                infoClassName='tool-tip tooltip-bottom-left font-12 sourcesanspro'
                infoIcon='icon-info color-primary'
                inputProps={{
                  className: 'font-12 poppins-medium title-color2 mb-1',
                  id: 'Subject',
                  name: 'Subject',
                  placeholder: 'Enter Subject',
                }}
                isInfo
                isMandatory
                label='Subject'
              />
            </div>
            <div className='col-dm-12 mb-2 mt-0'>
              <InputSelect
                className='form-sm font-13 sourcesanspro'
                defaultSelect={true}
                formClassName=' form-vertical'
                info='Comment For (Optional)'
                infoClassName='tool-tip tooltip-bottom font-12 sourcesanspro'
                infoIcon='icon-info color-primary'
                inputProps={{
                  className: 'font-12 poppins-medium title-color2 mb-1',
                  id: 'CommentFor',
                  name: 'Comment For',
                  placeholder: 'Select',
                }}
                isInfo
                label='Comment For (Optional)'
                onChange={(e: Event) => setSelectedFiles(e.target.value)}
                options={allFiles}
                value={selectedFiles}
              />
            </div>
            <div className='col-md-12 mt-0 mb-2'>
              <InputTextArea
                className='form-lg font-13 sourcesanspro  min-h-100 p-1'
                cols='30'
                error={validation.DiscComment}
                formClassName=' form-vertical'
                info='Comment'
                infoClassName='tool-tip tooltip-bottom-left font-12 sourcesanspro'
                infoIcon='icon-info color-primary'
                inputProps={{
                  className: 'font-12 poppins-medium title-color2 mb-1',
                  id: 'Comment',
                  name: 'Comment',
                  placeholder: 'Enter your Comment',
                }}
                isInfo
                isMandatory
                label='Comment'
                onChange={DiscussionComment}
                rows='3'
                type='textarea'
              />
            </div>
          </div>
          <div className='pt-2 d-flex gap-2 discussions-div'>
            <Buttons
              aria-label='Ok'
              className='btn btn-sm btn-primary whitetext font-11 border-radius ms-auto text-uppercase poppins-semibold'
              icon='icon-checked font-10 me-1'
              label='Ok'
              onClick={addDiscussions}
            />
            <ActionButtons
              className='btn-border1 title-color3 btn-sm font-11 border-radius text-uppercase poppins-semibold'
              icon='icon-close font-9 me-1 color-primary'
              id='Cancel'
              isClick='addDiscussion'
              label='Cancel'
              name='Cancel'
              popupCloseOpenFunctionality={popupCloseOpenFunctionality}
              ref={addDiscussion}
              showHide={showActionPopups.addDiscussion}
              type='button'
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </>
  )
}
export default AddDiscussion
